import { useGetUserGetQuery } from "@store";
import { useAppSelector } from "./index";

/**
 * Oturum açmış admin kullanıcısı. RTK Query cache'lediği için birden fazla
 * bileşenden çağrılması ek istek üretmez.
 */
export const useCurrentUser = () => {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);

  const { data, isLoading, isError } = useGetUserGetQuery(undefined, {
    skip: !isLoggedIn,
  });

  const user = data?.data;

  const fullName = [user?.name, user?.surname].filter(Boolean).join(" ");

  return {
    user,
    isLoading,
    isError,
    displayName: fullName || user?.userName || "",
    email: user?.email ?? "",
    roleTitle: user?.role?.title ?? "",
    avatar: user?.photos?.avatar || undefined,
  };
};

export default useCurrentUser;
